import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { Grid, GridColumn as Column, GridCell, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { fetchApi } from '../../services/api';

type Props = RouteComponentProps<{
    accountId: string;
 }>;

type State = {
    accountId: number;
    registrationToken: string;
    sort: SortDescriptor[];
    children: Child[];
    isLoading: boolean;
}

export interface Child {
    ChildID: number;
    ChildName: string;
    FacilityID: number;
    FacilityName: string;
    RegisteredDate: Date;
}

class ChildNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={ `/child/${ this.props.dataItem.ChildID }` }>
                    {this.props.dataItem.ChildName}
                </Link>
            </td>
        );
    }
}

class FacilityNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={ `/facility/${ this.props.dataItem.FacilityID }` }>
                    {this.props.dataItem.FacilityName}
                </Link>
            </td>
        );
    }
}

class DateCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td>{moment.utc(this.props.dataItem[this.props.field]).format("YYYY-MM-DD")}</td>
        );
    }
}

export default class AccountChildren extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            accountId: 0,
            registrationToken: '',
            children: [],
            isLoading: false,
            sort: [{field: "ChildName", dir: "asc"}],
        };

        this.getChildren = this.getChildren.bind(this);
        this.sortChange = this.sortChange.bind(this);
        this.openRegistrationForm = this.openRegistrationForm.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.getChildren(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.children && this.state.accountId != accountId) {
            this.getChildren(accountId);
        }
    }

    public render() {
        return <div>
            <br />
            <div className="row">
                <div className="col">
                    <h1>Children</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" onClick={this.openRegistrationForm}>Add Child</button>
                </div>
            </div>
            <Grid
                data={this.state.children}
                scrollable='none'
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
            >
                <Column field="ChildName" title="Name" cell={ChildNameCell} />
                <Column field="FacilityName" title="Facility" cell={FacilityNameCell} />
                <Column field="RegisteredDate" title="Registered" cell={DateCell} filter="date" />
            </Grid>
        </div>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            children: orderBy(this.state.children, event.sort)
        });
    }

    private getChildren(accountId: number) {
        this.setState({ isLoading: true, accountId});
        fetchApi(`api/Account/Children/${accountId}`)
            .then((response: { Children: Child[], RegistrationToken: string }) => {
                this.setState({
                    children: orderBy(response.Children, this.state.sort),
                    registrationToken: response.RegistrationToken,
                    isLoading: false
                });
            });
    }

    private openRegistrationForm() {
        window.open(`/registration/${this.state.accountId}/${this.state.registrationToken}`, '_blank');
    }
}
